import React from 'react';
import LoginScreen from '@/components/auth/LoginScreen';

const INVESTOR_BG = 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200';

export default function InvestorLogin() {
  return (
    <LoginScreen
      bg={INVESTOR_BG}
      badge="Area Partners"
      heroTitle="Il tuo investimento, sempre chiaro."
      heroText="Portale riservato ai partner finanziari: consulta l'andamento dei tuoi investimenti e scarica i documenti ufficiali condivisi dall'amministrazione."
      formTitle="Area Partners"
      formSubtitle="Accedi al portale riservato ai partner."
      showOAuth={false}
      testidPrefix="investor-login"
    />
  );
}
